<template>
	<div id="content_body">
		<header-layout :pageHeaderStyle="pageHeaderStyle" :pageHeaderBg="pageHeaderBg" :pageHeaderSpacing="pageHeaderSpacing" :pageHeaderContainer="pageHeaderContainer" :instanceClass="instanceClassAttr.instanceClass" :pageIcon="pageIcon"></header-layout>
		<div class="container mt-n15">
			<vue-collapsible-panel-group>
				<vue-collapsible-panel>
					<template #title>{{ $t('panel.criteria') }}</template>
					<template #content>
						<!-- CRITERES SEARCH -->
						<div class="datatable">
							<div class="card mb-4" style="width:100%">
								<div class="card-header">
									<div v-if="$store.getters.isAuthorized(['ROLE_MANAGER'])" class="form-row">
										<div align="center" class="col-md-6">
											<div class="btn-group" style="float: right;">
												<router-link class="btn btn-primary btn-sm" :to="{ name: 'mvtmovement', params: {typeMvt:1, typeDep:NaN, accId:NaN, typeAdd: 'one'} }">
													<fa icon="add"/> &nbsp;
													{{ $t('default.button.add') }}
												</router-link>
												<!-- <button class="btn btn-primary btn-sm" @click="modalToggle('NEW')" >
													<fa icon="add"/>&nbsp;
													{{ $t('default.button.add') }}
												</button> -->

											</div>
										</div>
									</div>
									<!-- <div id="panelList" class="card-body  panel-collapse collapse in show"> -->
									<div class="form-row">
										<div class="col-md-8">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.mvtAccount')}}
												</label>
												<!-- <select v-model="instance.mvtAccount" class="form-control" multiple>
													<option v-for="mvtAccount in mvtAccountList" :value="mvtAccount.id" :key="mvtAccount.id">
														{{ mvtAccount.lib}}
													</option>
												</select>	 -->

												<auto-search :paramsSearch="paramsSearch" @updateOnClick="addMvtAccount" />

												<input type="text" v-model="instance.mvtAccount" class="form-control" hidden=""/>								
											</div>
										</div>
										
										
										<div class="col-md-4">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.mvtTypeMvt')}}
												</label>
												<select v-model="instance.mvtTypeMvt" class="form-control">
													<option v-for="mvtTypeMvt in mvtTypeMvtList" :value="mvtTypeMvt.id" :key="mvtTypeMvt.id">
													{{ mvtTypeMvt.typeMvtName}}
													</option>
												</select>										
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>{{ $t('default.amountInf', { obj: $t(instanceClassAttr.instanceClass+'.mvtAmount')} ) }}</label>
												<input type="number" step="any" v-model="instance.amountInf" class="form-control" @input="amountToLetter($event, 'inf')" @change="amountLetter = {}"/>
												<span v-if="amountLetter && amountLetter.inf != '' " class="amount-letter">
													{{amountLetter.inf}}
												</span>
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>{{ $t('default.amountEq', { obj: $t(instanceClassAttr.instanceClass+'.mvtAmount')})}}</label>
												<input type="number" step="any" v-model="instance.amountEq" class="form-control" @input="amountToLetter($event, 'eq')" @change="amountLetter = {}"/>
												<span v-if="amountLetter && amountLetter.eq != '' " class="amount-letter">
													{{amountLetter.eq}}
												</span>
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>{{ $t('default.amountSup', { obj: $t(instanceClassAttr.instanceClass+'.mvtAmount')})}}</label>
												<input type="number" step="any" v-model="instance.amountSup" class="form-control" @input="amountToLetter($event, 'sup')" @change="amountLetter = {}"/>
												<span v-if="amountLetter && amountLetter.sup != '' " class="amount-letter">
													{{amountLetter.sup}}
												</span>
											</div>
										</div>
										
										<div class="col-md-4">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.mvtTypeDep')}}
												</label>
												<select v-model="instance.mvtTypeDep" class="form-control" multiple>
													<option v-for="mvtTypeDep in mvtTypeDepList" :value="mvtTypeDep.id" :key="mvtTypeDep.id">
													{{ mvtTypeDep.typeDepName}}
													</option>
												</select>										
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.prsStore')}}
												</label>
												<select v-model="instance.prsStore" class="form-control" multiple>
													<option v-for="prsStore in prsStoreList" :value="prsStore.id" :key="prsStore.id">
													{{ prsStore.storeName}}
													</option>
												</select>										
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.username')}}
												</label>
												<select v-model="instance.username" class="form-control" multiple>
													<option v-for="user in userList" :value="user" :key="user">
														{{ user}}
													</option>
												</select>										
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>{{ $t(instanceClassAttr.instanceClass+'.justificatif')}}</label>
												<input type="text" v-model="instance.justificatif" class="form-control" />
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>{{ $t('default.dateEntryAfter')}}</label>
												<input type="date" v-model="instance.dateEntryAfter" class="form-control" />
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>{{ $t('default.dateEntryBefore')}}</label>
												<input type="date" v-model="instance.dateEntryBefore" class="form-control" />
											</div>
										</div>

									</div> <!--end form-row-->
									<div style="text-align:center">
										<b-button class="btn btn-primary btn-sm"
											@click="search()">
											<fa icon="search"/>
												&nbsp; {{ $t('vtabTrans.sSearch') }}
										</b-button>
										&ensp;
										<button class="btn btn-light btn-sm" @click="reset()">
											<fa icon="refresh"/>
											&nbsp; {{ $t('vtabTrans.sReset') }}
										</button>
									</div>

										<!-- </div> -->
								</div>
							</div> <!--end card-body-->
							
						</div>
					</template>
				</vue-collapsible-panel>
				<br>
				<vue-collapsible-panel :expanded="false">
					<template #title>{{ $t('panel.chart') }}</template>
					<template #content>
						<!-- STATS -->
						<div>
							<chart
								:typeStats="typeStats"
								:chartData="chartData"
								:chartOptions="chartOptions"
								@refreshChart="drawChart"
							/>
						</div>
					</template>
				</vue-collapsible-panel>
				<br>
				<vue-collapsible-panel>
					<template #title>{{ $t('panel.data') }}</template>
					<template #content>
						<!-- DATA -->
						<div class="datatable">
							<datatable-instance
								:instanceClassAttr="instanceClassAttr"
								ref="componentDatatableInstance"
								@refreshChart="drawChart"
							/>
						</div>
					</template>
				</vue-collapsible-panel>
				
			</vue-collapsible-panel-group>

			<!-- ModalInstance  -->
			<div ref="modalInstance" class="modal fade" :class="{ show: active, 'd-block': active }" tabindex="-1" role="dialog">
				<div class="modal-dialog modal-dialog-centered modal-lg"
					role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title" v-if="modalType == 'NEW'">
								{{ $t('default.new') }}
							</h5>
							<h5 class="modal-title" v-if="modalType == 'EDIT'">
								{{ $t('default.edit') }}
							</h5>
							<b-button type="button" variant="close" @click="modalToggle()" />
						</div>
						<div class="modal-body">
							<b-container>
								<form role="form" id="modalFormInst" @submit.prevent="axiosPost">
									<div class="row d-flex justify-content-center ">
										<div class="col-md-3">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.mvtTypeMvt')}}
												</label>
												<select v-model="instanceModal.mvtTypeMvt" class="form-control">
													<option v-for="mvtTypeMvt in mvtTypeMvtList" :value="mvtTypeMvt.id" :key="mvtTypeMvt.id">
													{{ mvtTypeMvt.typeMvtName}}
													</option>
												</select>										
											</div>
										</div>
										<div class="col-md-9">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.mvtAccount')}}
												</label>
												<select v-model="instanceModal.mvtAccount" class="form-control">
													<option v-for="mvtAccount in mvtAccountList" :value="mvtAccount.id" :key="mvtAccount.id">
														{{mvtAccount.lib}}
													</option>
												</select>										
											</div>
										</div>
										<div class="col-md-7">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.mvtTypeDep')}}
												</label>
												<select v-model="instanceModal.mvtTypeDep" class="form-control">
													<option v-for="mvtTypeDep in mvtTypeDepList" :value="mvtTypeDep.id" :key="mvtTypeDep.id">
													{{ mvtTypeDep.typeDepName}}
													</option>
												</select>										
											</div>
										</div>
										
										<div class="col-md-5">
											<label>
												{{ $t(instanceClassAttr.instanceClass+'.mvtAmount')}}
											</label>
											<input type="number" step="any" v-model="instanceModal.mvtAmount" class="form-control" />
										</div>
										
										<div class="col-md-8">
											<label>
												{{ $t(instanceClassAttr.instanceClass+'.justificatif')}}
											</label>
											<input type="text" v-model="instanceModal.justificatif" class="form-control" />
										</div>
										<div class="col-md-4">
											<label>
												{{ $t(instanceClassAttr.instanceClass+'.mvtDate')}}
											</label>
											<input type="date" v-model="instanceModal.mvtDate" class="form-control" />
										</div>

									</div>
								</form>
							</b-container>
							

						</div> <!-- modal-body  -->
						<div class="modal-footer">
							<div class="row d-flex justify-content-end mb-3">
								<!-- <input type="hidden" id="id" name="id" :value="user.id" required> -->

								<!-- INFO v-if="!dataMapShow.readOnlyShow" -->
								<div class="mr-3">
									<button class="btn btn-success" :disabled="loading" @click="axiosPost">
										<span v-show="loading" class="spinner-border spinner-border-sm"/>
										<!-- v-if="!dataMapShow.infos.id" -->
										<span >
											{{ $t('default.button.create') }}
										</span>
										<!-- <span v-if="dataMapShow.infos.id">
											{{ $t('default.button.update') }}
										</span> -->
									</button>
								</div>
								<button type="button" class="btn btn-danger ml-1" @click="modalToggle()">
									{{ $t('default.button.cancel') }}
								</button>
							</div>
						</div> 


					</div> <!-- modal-content  -->
				</div> <!-- modal-dialog  -->
			</div> <!-- ModalInstance  -->
		
		</div>
	</div>

</template>
<script>
	import Header from '@/layouts/templates/Header.vue';
	import DatatableInstance from '@/components/templates/datatables/DatatableInstance.vue';
	import AutoSearch from '@/components/templates/AutoSearch.vue';
	import Chart from '@/components/templates/charts/Chart.vue';


	export default {
		name: 'mvtMovementList',
		components: {
			'header-layout': Header,
			'datatable-instance': DatatableInstance,
			'auto-search': AutoSearch,
			'chart': Chart
		},
		data() {
			return {
				pageHeaderStyle: process.env.VUE_APP_PAGE_HEADER_STYLE,
				pageHeaderBg: process.env.VUE_APP_PAGE_HEADER_BG,
				pageHeaderSpacing: 'pb-10',
				pageHeaderContainer: 'container',
				pageSubtitle: this.$t('mvtmovement.label'),
				pageTitle: this.$t('mvtmovement.list'),
				pageIcon: 'list',
				instanceClassAttr: {
					instanceClass: 'mvtmovement',
					routerShow: 'mvtmovementshow',
					titleIndex: 'nav.mvt',
					iconClass: 'folder',
					actCol: {
						actDisplay: true, 
						thCol: '10%', 
						actAdd: true, 
						actGet: true, 
						actEdit: true, 
						actDel: true, 
						actPrint: 'produce'
					},
					attrsList: [
						{attrName: 'mvtAccountLib', attrCol: '12%', searchable: true, sortable: true},
						{attrName: 'justificatif', attrCol: '13%', searchable: false, sortable: true},
						{attrName: 'mvtTypeDepLib', attrCol: '10%', searchable: false, sortable: true},
						{attrName: 'mvtTypeMvtLib', attrCol: '7%', searchable: false, sortable: true, attrRep:''},
						{attrName: 'mvtAmount', attrCol: '8%', searchable: false, sortable: true},
						{attrName: 'mvtSolde', attrCol: '10%', searchable: false, sortable: true},
						{attrName: 'mvtDate', attrCol: '10%', searchable: false, sortable: true},
						{attrName: 'usernameLib', attrCol: '10%', searchable: true, sortable: false, attrRep:''}
					]
				},
				instance: {
					mvtTypeDep: [],
					username: [],
					prsStore: [],
					mvtTypeMvt: '',
					mvtAccount: '',
					dateEntryAfter:'',
					dateEntryBefore:''
				},
				vueRules: {},
				paramsSearch: {
					placeholder: 'Search Account',
					instanceClass: 'mvtAccount',
					attrView: 'lib',
					filterList: [],
					btnReturn: false,
					icon: 'user',
				},
				mvtTypeDepList: [],
				mvtTypeMvtList: [],
				mvtAccountList: [],
				mvtAccountLib: '',
				prsStoreList: [],
				userList: [],
				amountLetter: {},
				chartData: [],
				chartOptions: {
					title: 'Statistique des mouvements par ',
					hAxis: {title: 'Désignation'},
					vAxis: {title: 'Montant'}
				},
				typeStats: [
					{id: 'mvtTypeDep', label: this.$t('mvttypedep.label')},
					{id: 'mvtAccount', label: this.$t('mvtaccount.label')},
					{id: 'mvtTypeMvt', label: this.$t('mvttypemvt.label')},
					{id: 'prsStore', label: this.$t('prsstore.label')}
					
					
				],
				typeStat: 'mvtTypeDep',
				
				instanceModal: {
					mvtTypeDep: '',
					mvtTypeMvt: '',
					mvtAccount: '',
					mvtAmount: '',
					justificatif: '',
					mvtDate: new Date ().toISOString().split('T')[0],
					username: this.$store.getters.username
				},

				active: false,
				modalType: 'NEW',
				loading: false,
					
			}
		},
		async mounted () {
			if(this.$store.getters.loggedIn) {
				// GET LIST mvttypedep
				await this.$store.dispatch('axiosGet', {
					domain: 'mvttypedep'
				})
				.then(response => {
					// console.log('this.mvtTypeDepList == ', this.mvtTypeDepList)
					this.mvtTypeDepList = response.data
				})
				.catch(error => {
					console.log('error catch mvttypedep == ', error.message)
				})
				// GET LIST mvtTypeMvtList
				await this.$store.dispatch('axiosGet', {
					domain: 'mvttypemvt'
				})
				.then(response => {
					this.mvtTypeMvtList = response.data
				})
				.catch(error => {
					console.log('error catch mvtTypeMvtList == ', error.message)
				})
				// GET LIST mvtAccountList
				await this.$store.dispatch('axiosGet', {
					domain: 'mvtaccount'
				})
				.then(response => {
					this.paramsSearch.filterList = response.data
					this.mvtAccountList = response.data
				})
				.catch(error => {
					console.log('error catch mvtAccountList == ', error.message)
				})
				// GET LIST prsstore
				await this.$store.dispatch('axiosGet', {
					domain: 'prsstore'
				})
				.then(response => {
					this.prsStoreList = response.data
					if(this.$store.getters.isAuthorized(['ROLE_VENTE'])){
						this.prsStoreList = this.prsStoreList.filter(item => item.id == this.$store.getters.prsInfo.prsStore)
						this.instance.prsStore.push(this.$store.getters.prsInfo.prsStore)
					}
				})
				.catch(error => {
					console.log('error catch prsStoreList == ', error.message)
				})
				// GET LIST user
				await this.$store.dispatch('axiosGet', {
					domain: 'user'
				})
				.then(response => {
					// this.userList = response.data
					response.data.forEach(element => {
						this.userList.push(element.username)
					});
					if(this.$store.getters.isAuthorized(['ROLE_VENTE'])){
							this.userList = this.userList.filter(item => item == this.$store.getters.username)
							this.instance.username.push(this.$store.getters.username)
					}
				})
				.catch(error => {
					console.log('error catch userList == ', error.message)
				})
				this.search();
			}
			// this.reset()
		},
		methods: {
			reset(){
				this.instance = {
					mvtTypeDep: [],
					username:[],
					prsStore:[],
					mvtTypeMvt: '',
					mvtAccount: '',
					amountSup: '',
					amountEq: '',
					amountInf: '',
					justificatif: '',
					dateEntryAfter:'',
					dateEntryBefore:'',
					
				};
			},
			addMvtAccount(row){
				if(row){
					this.instance.mvtAccount = row.id
					this.mvtAccountLib = row?.lib
				}
				else
					this.instance.mvtAccount = ''
			},
			async amountToLetter(e, attrName) {
				if(e.target.value && e.target.value.length > 2 && attrName && attrName != ''){
					await this.$store.dispatch('axiosGet', { url: '/api/sequence/convert?amount='+e.target.value
					})
					.then(response => {
						if(response.data && response.data.results)
							this.amountLetter[attrName] = response.data.results
					}).catch(error => {
						console.log('error catch convert amount == ', error.message)
					})
				}
			},
			async search() {
				let strParamsForms = "";
				let titreDoc = this.$t(this.instanceClassAttr.instanceClass +'.list')
				
				let	detailsTopC1 = '';
				let	detailsTopC2 = '';

				// Date super
				strParamsForms = strParamsForms+"&params1=mvtDate&valParams1="+this.instance.dateEntryAfter+"&logParams1=geD"
				if(this.instance.dateEntryAfter){
					detailsTopC2 = '<i>'+this.$t('default.dateEntryAfter')+' </i><b> '+ this.$moment(this.instance.dateEntryAfter).format(this.$store.getters.formatDateShort) + '</b>'
				}
				// Date inf
				strParamsForms = strParamsForms+"&params2=mvtDate&valParams2="+this.instance.dateEntryBefore+"&logParams2=leD"
				if(this.instance.dateEntryBefore){
					if(detailsTopC2 != '')
						detailsTopC2 = detailsTopC2 + ' - '
					else
						detailsTopC2 = detailsTopC2 + '<i>'+this.$t('default.dateEntryAfter')+' </i><b> ... </b>'

					detailsTopC2 = detailsTopC2 + '<i>'+this.$t('default.dateEntryBefore')+' </i><b> '+ this.$moment(this.instance.dateEntryBefore).format(this.$store.getters.formatDateShort) + '</b>'
				}

				strParamsForms = strParamsForms+"&params3=mvtTypeDep.id&valParams3="+this.instance.mvtTypeDep +"&logParams3=inL"

				// strParamsForms = strParamsForms+"&aliasList=_servTypeStockES"
				
				strParamsForms = strParamsForms+"&params4=mvtTypeMvt.id&valParams4="+this.instance.mvtTypeMvt +"&logParams4=eqL"

				strParamsForms = strParamsForms+"&params5=mvtAccount.id&valParams5="+this.instance.mvtAccount +"&logParams5=eqL"
				if(this.instance.mvtAccount && this.instance.mvtAccount != ''){
					if(detailsTopC1 != '')
						detailsTopC1 = detailsTopC1 + '<br>'
					detailsTopC1 = detailsTopC1 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.mvtAccount')+' : </i><b>'+ this.mvtAccountLib?.replace('|', '-') + '</b>'
				}
				
				// Amout super
				strParamsForms = strParamsForms+"&params6=mvtAmount&valParams6="+this.instance.amountSup+"&logParams6=geDo"
				if(this.instance.amountSup){
					if(detailsTopC2 != '')
						detailsTopC2 = detailsTopC2 + '<br>'
					detailsTopC2 = detailsTopC2 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.mvtAmount')+' > </i><b> '+this.$store.getters.formatAmount(this.instance.amountSup) + '</b>'
				}
				// Amout equal
				strParamsForms = strParamsForms+"&params7=mvtAmount&valParams7="+this.instance.amountEq+"&logParams7=eqDo"
				if(this.instance.amountEq){
					if(detailsTopC2 != '')
						detailsTopC2 = detailsTopC2 + '<br>'
					detailsTopC2 = detailsTopC2 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.mvtAmount')+' = </i><b> '+this.$store.getters.formatAmount(this.instance.amountEq) + '</b>'
				}
				// Amout inf
				strParamsForms = strParamsForms+"&params8=mvtAmount&valParams8="+this.instance.amountInf+"&logParams8=leDo"
				if(this.instance.amountInf){
					if(detailsTopC2 != '')
						detailsTopC2 = detailsTopC2 + '<br>'
					detailsTopC2 = detailsTopC2 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.mvtAmount')+'< </i><b> '+this.$store.getters.formatAmount(this.instance.amountInf) + '</b>'
				}				
				strParamsForms = strParamsForms+"&params9=username&valParams9="+this.instance.username +"&logParams9=inS"

				strParamsForms = strParamsForms+ "&titreDoc="+ titreDoc
				if(detailsTopC1 != '')
					strParamsForms = strParamsForms+"&detailsTopC1="+detailsTopC1
				if(detailsTopC2 != '')
					strParamsForms = strParamsForms+"&detailsTopC2="+detailsTopC2

				this.$refs.componentDatatableInstance.setStrParamsForms(strParamsForms);
				this.$refs.componentDatatableInstance.getDataByCriteria();
			},
			drawChart(val) {
				if(val && !Array.isArray(val))
					this.typeStat = val
				
				// default values
				let statLabel = [this.$t('mvttypedep.label'), "Montant par type de dépense"] 
				let attrKey = 'mvtTypeDep.typeDepName'
				let attrValue = 'mvtAmount'
				
				if(this.typeStat === 'mvtTypeDep' ){
					attrKey = 'mvtTypeDep.typeDepName'
				}
				else if(this.typeStat === 'mvtTypeMvt' ){
					statLabel = [this.$t('mvttypemvt.label'), "Montant par D/C"]
					attrKey = 'mvtTypeMvt.typeMvtName'
				}
				else if(this.typeStat === 'prsStore' ){
					statLabel = [this.$t('prsstore.label'), "Montant par Store"]
					attrKey = 'mvtAccount.prsPerson.prsStore.storeName'
				}
				else if(this.typeStat === 'mvtAccount' ){
					statLabel = [this.$t('mvtaccount.label'), "Montant par compte"]
					attrKey = 'mvtAccountLib'
				}

				var dataList = this.$refs.componentDatatableInstance.drawChart(attrKey, attrValue, null)
				this.chartData = [ statLabel ]
				dataList?.forEach(data => {
					this.chartData.push(data);	
				});
			},
			
			modalToggle(type) {
				// this.resetModal()
				this.modalType = type
				// this.language = this.$store.getters.language
				if(this.active)
					this.active = false
				else{
					this.active = true
					this.$nextTick(function(){
						// this.axiosShow(this.modalType)
					});
				}
			},
			async axiosPost() {
				try {
					await this.$store.dispatch('axiosPost', {
						domain: 'mvtmovement',
						data: this.instanceModal //data
					})
					.then(res => {
						this.instanceModal = res.data;
						// console.log('res.data ', res.data)
						this.modalToggle(this.modalType)
						this.$nextTick(() => {
							let msg = this.$t("mvtmovement.label") + " "+res.data.id;
							this.$store.dispatch('showToast', {
								type: 'success', message: this.$t('toast.created.message', { obj: msg})
							});
						});
					})
					.catch(error => {
						console.log('Error', error.response)
					})
					
				}
				catch (e) {
					console.log('Error ', e)
				}

			},
		}
		
	}

</script>